/****
 * LRR Versions 1.1.0
 */
const versionApp = '1.0'
require('./bootstrap');

import { ref, createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import { Inertia } from '@inertiajs/inertia';
import { initGA } from './analytics';

// LRR
import { createPinia } from "pinia";
import { useStyleStore } from "@/stores/style.js";
import { darkModeKey, styleKey } from "@/config.js";
import constanteApi from "@/conf-global.js";
import helpers from './Common/helpers';

// --- 1. CONFIGURACIÓN DE CONSTANTES ---
const constGlobal = ref({})
const getConstantes = async() => {
  try {
    const { data } = await constanteApi.get('/global')
    constGlobal.value = data.constantes
  } catch (error) {
    console.log('Error al consultar constantes', error)
  }
}
getConstantes()

const pinia = createPinia();

// --- 3. CONFIGURACIÓN DE INERTIA (COMPATIBLE CON WEBPACK) ---
createInertiaApp({
    // ACC; Importante: Evita conflictos de duplicidad en el título de la pestaña.
    title: (title) => title,

    resolve: (name) => require(`./Pages/${name}.vue`), // Cambio para Webpack
    
    setup({ el, app, props, plugin }) {
        const GA_ID = props.initialPage.props.google_analytics_id;

        if (GA_ID) {
            initGA(GA_ID);
        }
        // Actualiza el meta cada cambio de ruta sin recargar.
        Inertia.on('navigate', (event) => {
            const currentId = event.detail.page.props.google_analytics_id;
            if (window.gtag && currentId) {
                window.gtag('config', currentId, {
                    page_path: event.detail.page.url
                });
            }
        });

        const myApp = createApp({ 
            render: () => h(app, props),
            provide: {
                helpers: helpers
            }
        })
        .use(plugin)
        .use(pinia)
        .mixin({ methods: { route } });

        myApp.config.globalProperties.versionApp = versionApp;
        myApp.config.globalProperties.confGlobal = constGlobal;

        myApp.mount(el);
        return myApp;
    },
});

InertiaProgress.init({ color: '#4B5563' });

const styleStore = useStyleStore(pinia);
styleStore.setStyle(localStorage[styleKey] ?? "basic");

if (
    (!localStorage[darkModeKey] &&
      window.matchMedia("(prefers-color-scheme: dark)").matches) ||
    localStorage[darkModeKey] === "1"
  ) {
    styleStore.setDarkMode(true);
}